import PropTypes from 'prop-types';
import styles from './FJStyleItem.module.less';
import classNames from 'classnames';
import { useState } from 'react';
import FJLoading from '../../../common/components/FJLoading/FJLoading.jsx';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJImage from '../../../common/components/FJImage/FJImage.jsx';

const FJStyleItem = props => {
    const { imgSrc, onClick, className, selected } = props;
    // 正在应用该样式
    const [applying, setApplying] = useState(false);
    /**
     * @private
     */
    const _onClick = () => {
        setApplying(true);
        if (onClick)
            onClick(() => {
                setApplying(false);
            });
    };

    return (
        <div className={classNames(styles.container, className)} onClick={_onClick}>
            <FJHoverBoardGradation className={styles.hover_board_box} borderRadius={6} isShowInBorder active={selected}>
                <FJImage imgSrc={imgSrc} boxClassName={styles.img_box} imgClassName={styles.img} />
                {applying && (
                    <div className={styles.apply}>
                        <FJLoading style={{ width: 16, height: 16 }} />
                    </div>
                )}
            </FJHoverBoardGradation>
        </div>
    );
};
FJStyleItem.propTypes = {
    imgSrc: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};
export default FJStyleItem;
